var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJksFile = function SvgJksFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4 40V8h28.67L44 19.46V40H4zm5.13-21.18c0 1.13.73 2.1 2.22 2.1 1.4 0 2.3-.74 2.3-2.28v-4.5h-1.42v4.52c0 .7-.32 1-.9 1-.47 0-.83-.3-.85-.84H9.13zm11.3-4.68H18.9l-2.44 2.93h-.07v-2.93h-1.5v6.66h1.4v-2.1l.64-.75 1.8 2.85h1.7l-2.4-3.8 2.36-2.86zm.36 4.75c0 .9.6 2 2.6 2 1.6 0 2.6-.8 2.6-2.1 0-1.2-.85-1.7-1.8-1.9l-1-.2c-.6-.2-.9-.4-.9-.8 0-.5.4-.9 1.1-.9.8 0 1.13.42 1.2.9h1.3c0-1.2-1-2-2.5-2-1.4 0-2.54.72-2.54 2.03 0 1.13.8 1.66 1.72 1.86l1 .22c.66.13 1 .35 1 .8 0 .52-.4.87-1.2.87-.85 0-1.3-.43-1.33-.9h-1.3zm12.7 13.3l-1.9 1.4-.5-2.37-2.4-.08 1.1-2.1-1.8-1.6 2.2-.9-.35-2.37 2.3.73 1.26-2 1.3 2.07 2.28-.75-.3 2.33 2.2.9-1.8 1.6 1.14 2.1-2.4.1-.48 2.3-1.88-1.5z"
  }))));
};
export default SvgJksFile;